export const visit = (vm, at) => {
at({ "en": { "opt": { "optIn": "Try the new calling experience", "optOut": "Calling beta options", "showFeedback": "Submit Feedback" } } });
};